import { storableError } from '../../util/errors';
import { sendInviteEmails } from '../../util/api';
import * as log from '../../util/log';

const requestAction = actionType => params => ({ type: actionType, payload: { params } });

const successAction = actionType => result => ({ type: actionType, payload: result.message });

const errorAction = actionType => error => ({ type: actionType, payload: error, error: true });

// ================ Action types ================ //

export const SEND_EMAILS_REQUEST = 'app/InvitePage/SEND_EMAILS_REQUEST';
export const SEND_EMAILS_SUCCESS = 'app/InvitePage/SEND_EMAILS_SUCCESS';
export const SEND_EMAILS_ERROR = 'app/InvitePage/SEND_EMAILS_ERROR';
export const RESET_FORM = 'app/InvitePage/RESET_FORM';

// ================ Reducer ================ //

const initialState = {
  sendEmailsInProgress: false,
  sendEmailsError: null,
  emailsSent: false,
};

export default function invitePageReducer(state = initialState, action = {}) {
  const { type, payload } = action;
  switch (type) {
    case SEND_EMAILS_REQUEST:
      return {
        ...state,
        sendEmailsInProgress: true,
        sendEmailsError: null,
        emailsSent: false,
      };
    case SEND_EMAILS_SUCCESS:
      return {
        ...state,
        sendEmailsInProgress: false,
        emailsSent: true,
      };
    case SEND_EMAILS_ERROR:
      return {
        ...state,
        sendEmailsInProgress: false,
        sendEmailsError: payload,
      };
    case RESET_FORM:
      return initialState;

    default:
      return state;
  }
}

// ================ Action creators ================ //

export const sendEmailsRequest = requestAction(SEND_EMAILS_REQUEST);
export const sendEmailsSuccess = successAction(SEND_EMAILS_SUCCESS);
export const sendEmailsError = errorAction(SEND_EMAILS_ERROR);
export const resetForm = () => ({ type: RESET_FORM });

// ================ Thunks ================ //

export const sendEmails = params => async dispatch => {
  dispatch(sendEmailsRequest(params));

  sendInviteEmails(params)
    .then(response => {
      dispatch(sendEmailsSuccess(response));
    })
    .catch(e => {
      dispatch(sendEmailsError(storableError(e)));
      log.error(e, 'invite-emails-failed', {
        params,
        message: e.message,
      });
    });
};
